"use client";
import { Box, ChevronDown, Eye, EyeOff } from "lucide-react";
import { useEditorStore } from "@/stores/editorStore";
import { useSceneStore } from "@/stores/sceneStore";

export function SceneHierarchy() {
  const objects = useSceneStore((state) => state.objects);
  const replaceObjects = useSceneStore((state) => state.replaceObjects);
  const selected = useEditorStore((state) => state.selectedObjectId);
  const selectObject = useEditorStore((state) => state.selectObject);
  const toggleVisibility = (id: string) => {
    const next = objects.map((object) => object.id === id ? { ...object, visible: !object.visible } : object);
    replaceObjects(next, false);
  };
  return <section className="panel-section" style={{ borderTop: "1px solid var(--line)" }}>
    <div className="panel-title"><span>Scene Hierarchy</span><ChevronDown size={14} /></div>
    {objects.length === 0 ? <div className="empty-note">Scene is empty.<br />Add an asset to begin.</div> : objects.map((object) => (
      <div key={object.id} className={`hierarchy-row ${selected === object.id ? "selected" : ""}`}>
        <button className="hierarchy-select" onClick={() => selectObject(object.id)}><Box size={13} /><span>{object.name}</span></button>
        <button className="visibility-button" onClick={() => toggleVisibility(object.id)} title={object.visible ? "Hide object" : "Show object"}>{object.visible ? <Eye size={13} /> : <EyeOff size={13} />}</button>
      </div>
    ))}
  </section>;
}
